import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { IQuote } from '@/interfaces';
import { useI18n } from 'vue-i18n';
import { PaymentFrequency } from '@/enums/payment-frequency';
import { getDiscountsList } from '@/utils/iq-discounts';
import { TagSize, TagTypes } from '@/enums/tag-enums';
import TagList from '@/components/TagList/TagList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IQPolicyDiscounts',
  props: {
    quote: {},
    summaryHeading: {},
    showOnlineDiscount: { type: Boolean },
    showOnlineDiscountLast: { type: Boolean },
    noBorder: { type: Boolean },
    policyDiscounts: {},
    noPadding: { type: Boolean }
  },
  setup(__props: any) {

const { t, getLocaleMessage } = useI18n();
const dictionary: Record<string, string> = getLocaleMessage('en') as any;

const props = __props;

const policyDiscounts = computed(() => {
  const discounts = [] as string[];
  props.policyDiscounts?.forEach((value: string) => {
    discounts.push(dictionary[value]);
  });
  return discounts;
});

const discounts = computed(() =>
  getDiscountsList({ t, getLocaleMessage }, props.quote!, {
    showAsMonthly: props.quote?.paymentFrequency == PaymentFrequency.Monthly,
    showOnlineDiscount: props.showOnlineDiscount,
    showOnlineDiscountLast: props.showOnlineDiscountLast,
  })
);

return (_ctx: any,_cache: any) => {
  return (discounts.value?.length || policyDiscounts.value?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.noBorder ? '' : 'border-b')
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.noPadding ? '' : 'px-5 md:px-8 pt-2 md:pb-8 sm:pb-8')
        }, [
          (_ctx.summaryHeading)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: _normalizeClass([_ctx.noPadding ? '' : 'pt-5', "text-lg-bold title pb-2"])
              }, _toDisplayString(_ctx.summaryHeading), 3))
            : _createCommentVNode("", true),
          _createElementVNode("h5", {
            class: _normalizeClass([_ctx.noPadding ? '' : 'pt-5', "text-lg-bold inline-flex title pb-5"])
          }, _toDisplayString(_unref(dictionary).IQ_PolicyDiscountsHeading), 3),
          _createVNode(TagList, {
            tags: discounts.value?.length ? discounts.value : policyDiscounts.value,
            tagType: _unref(TagTypes).discount,
            tagSize: _unref(TagSize).sm
          }, null, 8, ["tags", "tagType", "tagSize"])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})